import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();

export default class CommandAPI {

    URI_V1 = "/v1/commands"

    createCommand = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    updateCommand = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    advancedSearch = async (commandId: any, filter: any) => {
        const params = {
            page: filter.page,
            limit: filter.limit,
            companyId: new CompanyAPI().getCompanyManagment().id,
            status: filter.status,
            startDate: filter.startDate,
            endDate: filter.endDate,
            employeeId: filter.employeeId,
            paymentType: filter.paymentType,
            commandId: commandId
        };

        // remove undefined, null e string vazia
        const cleanParams = Object.entries(params)
            .filter(([_, v]) => v !== undefined && v !== null && v !== '')
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join('&');

        return await apiService.get(`${this.URI_V1}/advanced-search?${cleanParams}`);
    };


    delete = async (commandId: any, companyId: any) => {
        return await apiService.delete(`${this.URI_V1}/${commandId}?companyId=${companyId}`);
    };

    createTransaction = async (commandId: any, data: any) => {
        return await apiService.post(`${this.URI_V1}/${commandId}/transaction`, data);
    };

    getTransactions = async (commandId: any) => {
        return await apiService.get(`${this.URI_V1}/${commandId}/transactions`);
    };

    deleteTransaction = async (commandId: any, transactionId: any) => {
        return await apiService.delete(`${this.URI_V1}/${commandId}/transaction/${transactionId}`);
    };

    findById = async (id: any) => {
        return await apiService.get(`${this.URI_V1}/${id}?companyId=${new CompanyAPI().getCompanyManagment().id}`);
    };

    applyGeneralPackage = async (commandId:any, data: any) => {
        return await apiService.post(`${this.URI_V1}/${commandId}/transaction/package/apply-general`, data);
    }
}
